/** Picks v2 or v1 of User Feedback based on the redesign flag. */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import FeedbacksPage   from './FeedbacksPage';
import FeedbacksPageV2 from './v2/FeedbacksPageV2';

export default function FeedbacksPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? FeedbacksPageV2 : FeedbacksPage;
  return <Component {...props} />;
}
